import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../../common/breadcrumbs";
// import Loader from "../../../common/loader";
import CustomCkeditor from "../../../common/customeditor";
import * as videoServices from "../../../services/video.services";
import {
    capitalizeFirstLetter,
    globalLoader,
    handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_500, VIDEO_CATEGORY } from "../../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";

const VideoEdit = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    const [dataLoaded, setDataLoaded] = useState(false);
    const [saveType, setSaveType] = useState("");
    const { t } = useTranslation()
    const [showVideoData, setShowVideoData] = useState({});
    const [previewimage, setPreviewImage] = useState("");

    const breadcrumbs = [
        { title: t("admin.faq.link_dashboard"), url: "/admin/dashboard/1" },
        { title: t("Video"), url: "/admin/cms/video/list/1" },
        { title: t("admin.faq.link_edit"), url: "" },
    ];

    useEffect(() => {
        videoServices
            .Details(params.id)
            .then((data) => {
                setShowDefault(data && data?.data ? data.data : []);
                setShowVideoData(data?.data?.video);
                setPreviewImage(data.data.thumbnail_image);
                setTimeout(() => {
                    setDataLoaded(true);
                }, 100);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, []);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            {dataLoaded ? (<Formik
                enableReinitialize
                initialValues={{
                    title: showdefault && showdefault.title ? showdefault.title : "",
                    description: showdefault && showdefault.description ? showdefault.description : "",
                    category: showdefault && showdefault.category ? showdefault.category : "",
                    video: showdefault && showdefault.video ? showdefault.video : "",
                    thumbnail_image: showdefault && showdefault.thumbnail_image ? showdefault.thumbnail_image : "",
                }}
                validate={(values) => {
                    const error = {};
                    const MAX_VIDEO_SIZE_MB = 100;
                    const allowedTypes = ["video/mp4", "video/webm", "video/ogg", "video/quicktime"];

                    if (!values.title || !values.title.trim()) {
                        error.title = "admin.faq.label_title_error";
                    } else if (values.title.length > INPUT_LENGTH_500) {
                        error.title = "admin.faq.validation_err_reached_maximum_length";
                    }

                    if (!values.description || !values.description.trim()) {
                        error.description = "admin.faq.label_description_error";
                    }

                    if (!values.category) {
                        error.category = "Category is required";
                    }

                    if (!values.video) {
                        error.video = "Please upload a video.";
                    } else {
                        const isFile = values.video instanceof File || values.video instanceof Blob;

                        if (isFile) {
                            if (!allowedTypes.includes(values.video.type)) {
                                error.video = "Invalid video format. Only MP4, WebM, MOV, or OGG allowed.";
                            }

                            const fileSizeMB = values.video.size / (1024 * 1024);
                            if (fileSizeMB > MAX_VIDEO_SIZE_MB) {
                                error.video = `Video size should not exceed ${MAX_VIDEO_SIZE_MB}MB.`;
                            }
                        }
                    }
                    return error;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    globalLoader(true);
                    let formData = new FormData();
                    formData.append("o_id", params.id);
                    formData.append("title", values.title);
                    formData.append("description", values.description);
                    formData.append("category", values.category);
                    formData.append("video", values.video);
                    if (values?.thumbnail_image) {
                        formData.append("thumbnail_image", values.thumbnail_image);
                    }
                    videoServices
                        .Edit(formData)
                        .then((response) => {
                            setSubmitting(false);
                            if (response.success) {
                                Swal.fire({
                                    icon: "success",
                                    text: response.message,
                                    ...SWAL_SETTINGS,
                                });
                                if (saveType !== "Save") {
                                    setTimeout(() => {
                                        resetForm({ values: "" });
                                        globalLoader(false);
                                        navigate(`/admin/cms/video/list/1`);
                                    }, 1000);
                                }
                                if (saveType === "Save") {
                                    setTimeout(() => {
                                        globalLoader(false);
                                    }, 1000);
                                }
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    text: handleServerValidations(response),
                                    ...SWAL_SETTINGS,
                                });
                                globalLoader(false);
                            }
                        })
                        .catch((error) => {
                            console.log("error ====> ", error);
                        });
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    setFieldTouched,
                    isSubmitting,
                }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row row-sm">
                            <div className="col-lg-12 col-md-12 animation_fade">
                                <div className="card custom-card">
                                    <div className="card-body">
                                        <div>
                                            <h6 className="main-content-label mb-3">{t("Edit Video")}</h6>
                                        </div>
                                        {showdefault && Object.keys(showdefault).length > 0 ? (
                                            <div className="row row-sm">

                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="title" className="text-left d-flex">
                                                        {t("admin.faq.list_heading_title")}:<span className="requirestar">*</span>
                                                    </label>
                                                    <input
                                                        name="title"
                                                        id="title"
                                                        type="text"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.title}
                                                        className="form-control"
                                                        placeholder={t("admin.faq.faq_title_placeholder")}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.title && touched.title && t(errors.title)}
                                                    </span>
                                                </div>

                                                <div className="col-md-6 text-center form-group">
                                                    <label className="text-left d-flex">
                                                        {t("Category")}
                                                        <span className="requirestar">*</span>
                                                    </label>
                                                    <select className="form-control form-select cp" name='category' value={values?.category} onChange={handleChange}>
                                                        <option value={""}>{t("Select")}</option>
                                                        {VIDEO_CATEGORY.map((item, index) => { return (<option key={index} value={item.value}>{capitalizeFirstLetter(item.label)}</option>) })}
                                                    </select>
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.category && touched.category && t(errors.category)}
                                                    </span>
                                                </div>

                                                <div className="col-lg-12 text-center form-group">
                                                    <label htmlFor="description" className="text-left d-flex">
                                                        {t("admin.faq.label_description")}:<span className="requirestar">*</span>
                                                    </label>
                                                    <CustomCkeditor
                                                        fieldname={"description"}
                                                        setFieldValue={setFieldValue}
                                                        value={values.description}
                                                        setFieldTouched={setFieldTouched}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.description &&
                                                            touched.description &&
                                                            t(errors.description)}
                                                    </span>
                                                </div>
                                                <div className="col-lg-6 text-center form-group">
                                                    <label htmlFor="thumbnail_image" className="text-left d-flex">
                                                        Upload Thumbnail Image:
                                                        {" "}
                                                    </label>
                                                    <input
                                                        className="form-control imgInput"
                                                        id="thumbnail_image"
                                                        name="thumbnail_image"
                                                        accept="image/*"
                                                        type="file"
                                                        onChange={(event) => {
                                                           setFieldValue(
                                                                "thumbnail_image",
                                                                event.target.files[0] || ""
                                                            );
                                                            event.target.files.length === 1
                                                                ? setPreviewImage(
                                                                    URL.createObjectURL(event.target.files[0])
                                                                )
                                                                : setPreviewImage("");
                                                        }}
                                                    />
                                                    {previewimage ? (
                                                        <ul className="question-image-preview questions-ul">
                                                            <li className="pr_img_box">
                                                                <img
                                                                    src={previewimage}
                                                                    style={{ height: "100px" }}
                                                                    alt={"profileImg"}
                                                                />
                                                            </li>
                                                        </ul>
                                                    ) : (
                                                        ""
                                                    )}
                                                </div>
                                                <div className="col-lg-12 text-center form-group">
                                                    <label htmlFor="video" className="text-left d-flex">
                                                        {t("Upload Video")}:<span className="requirestar">*</span>
                                                        <Whisper
                                                            placement="top"
                                                            controlId="control-id-hover"
                                                            trigger="hover"
                                                            speaker={
                                                                <Tooltip>
                                                                    Maximum video upload size 100MB
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <span className="field-more-info mt-1 ms-1 cp">
                                                                ?
                                                            </span>
                                                        </Whisper>
                                                    </label>
                                                    <input
                                                        type="file"
                                                        name="video"
                                                        id="video"
                                                        accept="video/*"
                                                        className="form-control"
                                                        onChange={(event) => {
                                                            setFieldValue("video", event.currentTarget.files[0]);
                                                        }}
                                                    />
                                                    <span className="text-danger d-flex text-left">
                                                        {errors.video &&
                                                            touched.video &&
                                                            t(errors.video)}
                                                    </span>
                                                </div>

                                                {showVideoData ? (
                                                    <ul className="question-image-preview questions-ul">
                                                        <li className="pr_img_box">
                                                            <video
                                                                src={showVideoData}
                                                                style={{ height: "100px" }}
                                                                controls
                                                            />
                                                        </li>
                                                    </ul>
                                                ) : null}


                                                <div className="">
                                                    <button
                                                        onClick={() => {
                                                            setSaveType("Save");
                                                        }}
                                                        className="btn btn-info mr-2"
                                                        type="submit"
                                                    >
                                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                        {t("admin.button.btn_save")}
                                                    </button>
                                                    <button
                                                        onClick={() => {
                                                            setSaveType("");
                                                        }}
                                                        className="btn btn-success mr-2"
                                                        type="submit"
                                                    >
                                                        <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                                        {t("admin.button.btn_save_exit")}
                                                    </button>
                                                    <button
                                                        className="btn ripple btn-secondary"
                                                        type="button"
                                                        onClick={() => navigate(-1)}
                                                    >
                                                        <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                                        {t("admin.button.btn_cancel")}
                                                    </button>
                                                </div>
                                            </div>
                                        ) : (
                                            <Loader />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                )}
            </Formik>
            ) : (
                <Loader />
            )}

        </>
    );
};

export default VideoEdit;
